import { fileUrl } from "@/lib/api";

export const Avatar = ({ url, name, cls = "w-9 h-9 text-sm", testid }) => (
  url ? (
    <img src={fileUrl(url)} alt="" data-testid={testid} className={`${cls} rounded-full object-cover border border-pastel shrink-0`} />
  ) : (
    <div data-testid={testid} className={`${cls} rounded-full bg-canard/10 flex items-center justify-center text-canard font-heading font-extrabold shrink-0`}>{(name || "?").charAt(0).toUpperCase()}</div>
  )
);
